angular.module('config', []);
angular.module('utils', ['config']);
angular.module('templates', ['utils']);
angular.module('services', ['utils']);
angular.module('dental', ['ngRoute', 'ngAnimate', 'LocalStorageModule', 'config',
							'utils', 'services', 'templates', 'pascalprecht.translate']);

angular.module('dental')
	.config(['$locationProvider', 'localStorageServiceProvider',
		'$sceDelegateProvider',
		function($locationProvider, localStorageServiceProvider,
		$sceDelegateProvider) {
		localStorageServiceProvider.setPrefix('dentalFormStorage');
		$locationProvider.html5Mode({
			enabled: true,
			requireBase: false
		});

		$sceDelegateProvider.resourceUrlWhitelist([
			'self',
			'https://centaurportal.com/**'
		]);
}])
.controller('MainController', ['$scope', function ($scope) {
	$scope.$watch('popup', function (newVal) {
		if (newVal === undefined) {
			return;
		} else if (newVal !== '') {
			history.pushState({}, 'Title', window.location.pathname);
		}
	});
}]);
